import Vue from 'vue/dist/vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie'
import Vuelidate from 'vuelidate'
import Toast from 'vue-easy-toast'

Vue.use(VueResource)
Vue.use(VueCookie)
Vue.use(Vuelidate)
Vue.use(Toast)

import HeaderView from 'app/components/shared/HeaderView'
import ArsenalOneOrderCables from 'app/components/orders/ArsenalOneOrderCables'

window.addEventListener('load', function () {
  new Vue({
    el: '#app',
    components: {
      HeaderView,
      ArsenalOneOrderCables
    }
  })
})
